import {
  Button,
  Buttons,
  Card,
  CardContent,
  Checkbox,
  Flex,
  Link,
  Text,
  Appear,
} from '@bitrise/bitkit';
import { firestore } from 'firebase/app';
import React, { SyntheticEvent, useContext, useEffect, useState, FunctionComponent } from 'react';
import { trackEvent } from '../../../utils/tracking';
import { AuthContextFirebase } from '../../Authenticate/AuthenticateFirebase';
import { AuthContextTrace } from '../../Authenticate/AuthenticateTrace';
import { FeatureContext } from '../../Features/useFeatures';
import { URLStateContext } from '../../URLState/URLState';
import TermsOfServiceModal from './TermsOfServiceModal';

const TermsOfService: FunctionComponent = () => {
  const { push } = useContext(URLStateContext);
  const { hasFeature } = useContext(FeatureContext);
  const {
    data: { appId },
  } = useContext(AuthContextTrace);
  const {
    data: { hasAgreedTermsOfService: hasAgreedTermsOfServiceInitial },
  } = useContext(AuthContextFirebase);
  const [isTermsOfServiceVisible, setIsTermsOfServiceVisible] = useState(false);
  const [hasAgreedTermsOfService, setHasAgreedTermsOfService] = useState(
    hasAgreedTermsOfServiceInitial,
  );

  const handleAccept = async () => {
    await firestore().collection('flags').doc(appId).set({ hasAgreedTermsOfService: true });

    trackEvent('Onboarding.Welcome.Complete', {});

    if (hasFeature('enable-builds-performance')) {
      push(`/${appId}`);
    } else {
      push(`/${appId}/o/getting-started`);
    }
  };

  const handleShowTermsOfService = (event: SyntheticEvent) => {
    event.preventDefault();
    setIsTermsOfServiceVisible(true);
    trackEvent('Onboarding.Welcome.ViewedToS', {});
  };

  const handleAcceptTermsOfService = (hasAgreed: boolean) => {
    setHasAgreedTermsOfService(hasAgreed);
    setIsTermsOfServiceVisible(false);
    trackEvent('Onboarding.Welcome.AcceptedToS', {});
  };

  useEffect(() => {
    trackEvent('Onboarding.Welcome.Visit', {});
  }, []);

  return (
    <Appear animation="Fade" duration="base">
      <Card maxWidth="56.25rem">
        <CardContent backgroundColor="gray-1" padding="x10">
          <Text align="middle" config="4" margin="x3">
            Trace helps you catch bugs before they reach your users.
          </Text>

          <Text margin="x6">
            <Text align="middle">
              First, let&apos;s get the formalities out of the way. Like every service, we have some
              terms.
            </Text>

            <Text align="middle">Take a look, and when you&apos;re happy we can continue.</Text>
          </Text>

          <Flex margin="x6" textColor="grape-1">
            <TermsOfServiceModal
              onAccept={() => handleAcceptTermsOfService(true)}
              onClose={() => setIsTermsOfServiceVisible(false)}
              onDecline={() => handleAcceptTermsOfService(false)}
              visible={isTermsOfServiceVisible}
              width="600px"
            />

            <Flex maxWidth="300px">
              <Checkbox
                checked={hasAgreedTermsOfService}
                onChange={(event) => handleAcceptTermsOfService(event.target.checked)}
              >
                You agree to the {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link clickable onClick={handleShowTermsOfService} underline>
                  Terms of Service
                </Link>
                ?
              </Checkbox>
            </Flex>
          </Flex>

          <Buttons alignChildrenHorizontal="middle" margin="x6">
            <Button
              disabled={!hasAgreedTermsOfService}
              level="primary"
              onClick={handleAccept}
              size="large"
            >
              Let&apos;s go
            </Button>
          </Buttons>
        </CardContent>
      </Card>
    </Appear>
  );
};

export default TermsOfService;
